import { SetupContext, getCurrentInstance, computed } from 'vue';
// eslint-disable-next-line import/no-extraneous-dependencies
import { Feed } from '@/api/feed';
import { roundingNum } from '@/common/utils';
import { sendLog } from '@/common/radar';

type PhotoActionItemProps = {
    index?: number;
    feed?: Feed;
    isLoginStatus?: boolean;
};

export const PhotoActionItemCommonSetup = (props: PhotoActionItemProps, _: SetupContext<Array<'onCommentBtnClick' | 'sendActionRecoLog'>>) => {
    const { proxy } = getCurrentInstance() as { proxy: any };

    const formattedLikeCount = computed(() => {
        return props.feed?.like_count && props.feed?.like_count > 0 ? roundingNum(props.feed.like_count) : proxy?.$root?.$t('k_344306') ?? '';
    });

    const formattedCommentCount = computed(() => {
        return props.feed?.comment_count && props.feed?.comment_count > 0
            ? roundingNum(props.feed.comment_count)
            : proxy?.$root?.$t('k_467898') ?? '';
    });

    const formattedDownloadCount = computed(() => {
        return proxy?.$root?.$t('download') ?? '';
    });

    const cardCommonParams = computed(() => {
        return {
            card_type: 'photo_card',
            card_position: props.index,
        };
    });

    const onCommentUserNameClick = (kwaiId?: string) => {
        proxy?.$router?.push({ path: `/@${kwaiId ?? ''}`, query: { page_source: 'new_discover' } });

        sendLog({
            type: 'click',
            name: 'PHOTO_CARD_SPECIAL',
            value: {
                button_type: 'comment_icon',
                ...cardCommonParams.value,
            },
        });
    };

    return {
        formattedLikeCount,
        formattedCommentCount,
        formattedDownloadCount,

        onCommentUserNameClick,
    };
};
